'use client';

import {
  Configure, Hits, InstantSearch, useInstantSearch,
} from 'react-instantsearch';
import searchClient from 'utils/algolia';
import EmptySearch from 'components/EmptySearch/EmptySearch';
import { Loading } from 'components/Loading';
import { ALGOLIA_INDEX_NAME } from 'constants/algolia';
import { HitsItem, HitsList } from '../../AlgoliaSearchEvents.css';
import { AlgoliaSearchHit } from '../AlgoliaSearchHit/AlgoliaSearchHit';
import { Title } from './SearchOtherCities.css';


type SearchOtherCitiesProps = {
  userTokenAlgolia: string;
  termSearch: string;
};

function ResultsOtherCities() {
  const { results, status } = useInstantSearch();
  if (status === 'loading') return <Loading />;
  if (results?.nbHits === 0) return <EmptySearch />;

  return (
    <>
      <EmptySearch hasOtherResult />
      <h2 className={Title}>
        {`${results?.query} em outras cidades`}
      </h2>
      <Hits classNames={{ list: HitsList, item: HitsItem }} hitComponent={AlgoliaSearchHit} />
    </>
  );
}

function SearchOtherCities({ userTokenAlgolia, termSearch }: SearchOtherCitiesProps) {
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={ALGOLIA_INDEX_NAME}
      insights
    >
      <Configure hitsPerPage={5} userToken={userTokenAlgolia} facetFilters={[]} query={termSearch} />
      <ResultsOtherCities />
    </InstantSearch>
  );
}

export default SearchOtherCities;